import { IconButton, styled } from '@mui/material';

import { useState } from 'react';

import { Table, UserCard } from '@app-velocity/ui';

import { EllipsisIcon } from '@app-velocity/icons';

import { UnifiedTeamMember } from '../../../../../../types';

import { Status } from '../Status';
import { Role } from '../Role';
import { ContextMenu } from '../ContextMenu';

export type SingleMemberProps = {
  member: UnifiedTeamMember;
};

const StyledUserCard = styled(UserCard)<{ expired: boolean }>(
  ({ expired }) => ({
    padding: 0,
    fontSize: 14,
    opacity: expired ? 0.5 : 1,
  })
);

export const SingleMember = ({ member }: SingleMemberProps) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const openMenu = (e: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(e.currentTarget);
  };

  const isExpired = member.expiresAt && new Date().getTime() > member.expiresAt;

  return (
    <Table.Row>
      <Table.Cell>
        <StyledUserCard email={member.email || '-'} expired={!!isExpired} />
      </Table.Cell>

      <Table.Cell>
        <Role role={member.role} />
      </Table.Cell>
      <Table.Cell>
        <Status status={member.status} />
      </Table.Cell>
      <Table.Cell>
        {member.role && ['ADMIN', 'MEMBER'].includes(member.role) ? (
          <>
            <IconButton onClick={openMenu}>
              <EllipsisIcon />
            </IconButton>
            <ContextMenu
              anchor={menuAnchor}
              onClose={closeMenu}
              member={member}
            />
          </>
        ) : null}
      </Table.Cell>
    </Table.Row>
  );
};
